module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"position":"Full-Stack Developer & UI/UX Engineer","resume":"Resumé","contact":"Contact Me"},"de":{"position":"Fullstack Web- und UI/UX Entwickler","resume":"Resümee","contact":"Kontakt"}}')
  delete Component.options._Ctor
}
